import { render, staticRenderFns } from "./DetailsRight.vue?vue&type=template&id=65176310&scoped=true"
import script from "./DetailsRight.vue?vue&type=script&lang=js"
export * from "./DetailsRight.vue?vue&type=script&lang=js"
import style0 from "./DetailsRight.vue?vue&type=style&index=0&id=65176310&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65176310",
  null
  
)

export default component.exports